import type { MetaFunction } from "react-router";
import { SITE_NAME } from "@/lib/constants";
import NotFound from "@/pages/NotFound";

export const meta: MetaFunction = () => [
  { title: `Page Not Found | ${SITE_NAME}` },
  { name: "description", content: "The page you're looking for doesn't exist or has been moved." },
  { name: "robots", content: "noindex" },
];

export default function CatchAllRoute() {
  return <NotFound />;
}
